import {stateData, reduxState} from '../../values';

export const getContacts = (data) =>{
    return(dispatch) =>{
        dispatch({
            type:       reduxState.get_contacts,
            payload:    data.Data,
            status:     stateData.state2,
            records:    data.Records
        })
    }
}

export const updateContacts= (data) =>{
    return(dispatch) =>{
        dispatch({
            type:       reduxState.update_contacts,
            payload:    data,
        })
    }
}